<template>
  <div class="graph card">
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css" integrity="sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N" crossorigin="anonymous">
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
    <!--<meta http-equiv="refresh" content="3600"> refresh page every 60 min -->
    
    <div>
        <router-link :to="{ name: 'my-kh', params: { language: $route.params.language }}"> <!--Aquawiz按鍵-->
                  <button style="background-color:#fff;border:none;">
                  <img src="../assets/AquaWiz_trans_minimum.png" width="110"></button>
        </router-link>
        <span v-if="serial.startsWith('KH1')"><img style="width: 20px;" src="../assets/KHA.png"></span>
				<span v-if="serial.startsWith('KH2')"><img style="width: 25px;" src="../assets/KHApro.png"></span>
        <span v-if="serial!=devname" style="font-size:1.1em; color:red; "><strong>{{s_number}} {{devname}}</strong></span>
        <span v-else style="font-size:1.1em; color:red; "><strong>{{devname}}</strong></span>

        <span style="float:right;">
        <button type="reset" class="btn-primary" @click="fillData(1)" style="font-size: 12px;border-radius: 5px">{{msglist[$route.params.language][0]}}</button>
        <button type="reset" class="btn-primary" @click="fillData(3)" style="font-size: 12px;border-radius: 5px">{{msglist[$route.params.language][5]}}</button>
        <button type="reset" class="btn-primary" @click="fillData(7)" style="font-size: 12px;border-radius: 5px">{{msglist[$route.params.language][1]}}</button>
        <button type="reset" class="btn-primary" @click="fillData(30)" style="font-size: 12px;border-radius: 5px">{{msglist[$route.params.language][2]}}</button>
        <button type="reset" class="btn-primary" @click="fillData(365)" style="font-size: 12px;border-radius: 5px">{{msglist[$route.params.language][3]}}</button>
        <button type="reset" class="btn-primary" @click="row2csv()" style="font-size: 12px;border-radius: 5px">{{msglist[$route.params.language][8]}}</button>
        </span>
        
        <span v-if="er_c>=5" style="float:right;color:red;"><strong>&nbsp;&nbsp;#{{er_pump}}{{msglist[$route.params.language][9]}} </strong></span>
        <span v-if="phSignal<0" style="float:right;"></span>  
        <span v-else-if="phSignal>=0 && phSignal<100" style="float:right;color:red;"><strong>{{msglist[$route.params.language][6]}} {{ phSignal }}%,{{msglist[$route.params.language][7]}}</strong></span>
        <span v-else-if="phSignal>=100 && phSignal<1000" style="float:right;"><strong>{{msglist[$route.params.language][6]}}100%</strong></span>
        <span v-else style="float:right;color:red;"><strong>{{msglist[$route.params.language][6]}} fail,{{msglist[$route.params.language][7]}}</strong></span>
        
      </div> 
          <line-graph v-if="win_width>win_height" :chart-data="datacollection" :options="choptions" style="position: relative; height:90vh; width:100%"></line-graph>
          <line-graph v-else :chart-data="datacollection" :options="choptions" style="position: relative; height:45vh; width:100%"></line-graph>
    
     <div v-if="ph1 !=-1 && win_width<win_height" class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
		  		<div class="col-12 row mx-0" v-html="msglist[$route.params.language][10]"></div>	
			
		  	</div>
    </div>
         
</template>

<script>
/////////////////////////////////////////////////////////////////////
// 9/4/22 allow KH2 to plot field26 
/////////////////////////////////////////////////////////////////////

import Log from 'loglevel';
import has from 'lodash/has';
import map from 'lodash/map';
import LineGraph from './LineGraph.vue';

const mlist = {
	'en': [
		'Day',
		'Week',
		'Month',
		'Year',
    'My KH',
    '3 days',
    'PH probe ',
    'Please change ',
    'Download',
    ' Pump fail ',
    `<ul style="margin-left: 0; padding-left: 0">
    <li>PH - Aquarium water pH</li>
    <li>PH(O) - pH after full aeration, representing the maximum achievable under current air conditions.</li>
    <li>&Delta;PH = PH - PH(O) Should be > -0.3, a relative value, no need to calibrate pH probe.</li>
    <li>Monitor & adjust methods to increase pH.</li>
    <li>Methods to raise pH: Reduce livestock & feeding, improve skimmer & aeration, ventilate, lower CO2, use outdoor air for skimmer, increase light, use algae refugium/scrubber, limewater, CO2 absorbent.</li>
    <li>Example: If &Delta;PH drops, check skimmer impeller, light brightness, limewater, or CO2 absorbent.</li></ul>
    `],
  'vi': [
    'Ngày',
		'Tuần',
		'Tháng',
		'Năm',
    'KH Của Tôi',
    '3 ngày',
    'Tình Trạng Đầu Dò PH',
    'Hãy thay đổi ',
    'Tải Xuống',
    ' Pump fail '],
  'ms': [
		'Day',
		'Week',
		'Month',
		'Year',
    'My KH',
    '3 days',
    'PH probe ',
    'Please change ',
    'Download',
    ' Pump fail '],
	'tw': [
		'天',
		'週',
		'月',
		'年',
    '我的KH',
    '3天',
    'PH計',
    '請更換 ',
    '下載',
    '馬達故障 ',
    `<ul style="margin-left: 0;padding-left: 0"><li>PH - 魚缸pH值</li><li>PH(O) - 魚缸水經充分曝氣後的pH，為現有環境空氣能提供的上限，努力的目標。</li>
      <li>&Delta;PH = PH-PH(O) 正常值應大於-0.3，此為相對值，與絕對值無關，可免校正pH棒。</li>
      <li>可監控調整所有增加PH值的方法。</li>
      <li>增加pH的方法： 減少生物及餵食，加大蛋白機，充分曝氣，室內通風，減少CO2，蛋白機吸室外空氣，主燈提高亮度，藻缸藻屏，行光合作用，氫氧化鈣水，CO2吸附劑</li>
      <li>範例，&Delta;PH變低了，檢查蛋白機刷葉是否要清洗，主燈或藻燈亮度衰退，氫氧化鈣水不足，要更換CO2吸附劑</li></ul>
      `],
	'cn': [
		'天',
		'週',
		'月',
		'年',
    '我的KH',
    '3天',
    'PH计',
    '请更换 ',
    '下载',
    '马达故障 ',
    `<ul style="margin-left: 0;padding-left: 0"><li>PH - 鱼缸pH值</li><li>PH(O) - 鱼缸水经过充分曝气后的pH值，为当前环境空气所能提供的上限，是努力的目标。</li>
      <li>&Delta;PH = PH - PH(O) 正常值应大于 -0.3，这是相对值，与绝对值无关，可免校准pH探头。</li>
      <li>可监控并调整所有提高pH值的方法。</li>
      <li>提高pH的方法：减少生物数量和喂食、加强蛋白分离器、充分曝气、室内通风、减少CO2、蛋白分离器吸入室外空气、提高主灯亮度、使用藻缸或藻屏进行光合作用、添加氢氧化钙水、使用CO2吸附剂。</li>
      <li>示例：&Delta;PH变低时，检查蛋白分离器叶片是否需要清洗、主灯或藻灯亮度是否下降、氢氧化钙水是否不足，或CO2吸附剂是否需要更换。</li></ul>
    `],
}

//let PURL = process.env.SERVER;


function getFieldValues(res, fieldName) {
  let fValues = [];
  //console.log('data field: ', fieldName);
  if (fieldName.match(/^field/)) {
    fValues = map(res, function (entry) {
      //console.log("field:", fieldName, " entry: ", entry[1], entry.length);
      if (entry.length >= 2) {
        let obj = entry[1];
        return obj[fieldName];
      } else {
        return "undefined";
      }
    });
  }
  //console.log("field:", fieldName,"data values: ", fValues);
  return fValues;
}


function getGraph(Vue, range, serial) {
  
  let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {};   
  let date = new Date().toJSON().slice(0,10);  //2023-03-06T08:44:50.444Z slice(0,10) ==>2023-03-06
  let stTime = new Date(date).getTime() - (range * 24 * 60 * 60 * 1000); //console.log("stTime: ", new Date().getDate(), new Date().toJSON());
  let stDate = new Date(stTime).toJSON();
  
  if (Vue.$route.params.sidx != null) {localStorage.setItem('sidx', Vue.$route.params.sidx);} // when reload webpage, sidx will be forget and = undefined, null
  let sidx=localStorage.getItem('sidx');  // restore sidx from localstorage after webpage reload
  if (range != null) {localStorage.setItem('range', range);} // when reload webpage, range will be forget and = undefined, null
  range=localStorage.getItem('range');  // restore range from localstorage after webpage reload
  serial = user.data.devices[sidx]; 
  //Vue.s_number = serial.split('-')[2].substring(2);  // 00002.substring(2) = 002
  Vue.s_number= user.s_number[sidx];
  Vue.devname= user.devname[sidx];
  Vue.er_pump= user.er_pump[sidx];
  Vue.er_c= user.er_c[sidx];
  Vue.serial = serial; //to display on graph
  let PURL = localStorage.getItem("server") || process.env.SERVER;
  let url = PURL + '/api/v1/query/device/' + serial + '/graph';
  
  if (range > 0) {
    // url += '?stTime=' + stTime;
    url += '?date=' + stDate;
  }

  // asynch call
  if (serial) {
    let rftime=localStorage.getItem('rftime'); // get last webpage refresh time
    let rfmin=Math.abs((new Date() - new Date(rftime)))/1000; // get time difference between page reload
    let res =localStorage.getItem('res'); // way to check res exist or not
    //console.log('rfmin',rfmin, 'rftime', rftime);
    
    if (rfmin > 600 || range >1 || rftime===null || res===null) {       // time difference bwtween reload > 60 sec, or request range more than 1 day, then load data from server
                                        //from my-kh to kh-graph page, if rftime=null, then rfmin = 1689581007 sec
      /////// get data from server //////  
      //console.log('KH-graph -- get data from server');
      let p0 = Vue.$http.get(url);
        Promise.all([p0]).then(([r0]) => {
          //console.log("get graph data from server");
          Vue.message = 'graph returned';
          if (has(r0, "body.results.length") && r0.body.results.length !== 0) {
            res = r0.body.results; 
            if (range==1) {localStorage.setItem('res', JSON.stringify(res)); localStorage.setItem('rftime',new Date());}  // local save range=1 all data to reduce call API
            setGraphData(user, serial, res, Vue);
          }
        }, reason => {    // promise.all
          let rea=JSON.stringify(reason) ; 
          Vue.message = 'error: unknown error: ' + rea;
          if (rea.match(/no serial/gi)) {
            Vue.message = 'invalid serial numer';
          }
          console.log("reason: ", rea);
        });
      } else {  
        /////// get data from localstorage /////
        //console.log('KH-graph -- get data from localstorage');
        res = JSON.parse(localStorage.getItem('res'));
        setGraphData(user, serial, res, Vue);
      }
      
  } else {    // if serial
      console.log('serial not found');
      Vue.message = 'serial not found';
  }    
  

  }



function setGraphData (user, serial,res, Vue) {        
  console.log("KH-graph -- get data ", serial);
    // times = map(res, function(entry) { return entry[0]; });
    // tbd: change to minute later
    let times = [];times = map(res, function(entry) { return new Date(entry[0]); });
    let fields=['field22', 'field23', 'field24', 'field25', 'field26', 'field27', 'field28']
    //let fields = Object.keys(res[0][1]);
    //console.log("fields:", fields, " res: ", res[0][1]);
    let data = {
      labels: times,
      datasets: [],
    };
    let sidx=localStorage.getItem('sidx');
    Vue.phSignal= user.phSignal[sidx];
    Vue.ph1= user.ph1[sidx];
      ////////// field 22 Tank KH ///////////
        let field22 = fields[0]; var maxdata22 = 0; var mindata22 = 100; var total22 = 0;
        let dataEntry22 = {
          label: 'KH',
          borderColor: '#6633ff', backgroundColor: '#6633ff', 
          pointHoverBorderColor: 'black', pointHoverRadius: 5, pointHoverBackgroundColor: 'black',
          fill: false,
          yAxisID: 'y-axis-1',
          data: []
        };  
        dataEntry22.data = getFieldValues(res, field22);
        for (let k = 0; k<dataEntry22.data.length; k++) {
          dataEntry22.data[k] = dataEntry22.data[k]/1000;
          maxdata22=Math.max(dataEntry22.data[k],maxdata22);
          mindata22=Math.min(dataEntry22.data[k],mindata22);
          total22+=dataEntry22.data[k];
        }
        data.datasets.push(dataEntry22);
        let range22=Math.max((maxdata22-mindata22), 4.0-(maxdata22-mindata22));  // display range >=4.0 dKH
        let average22=total22/dataEntry22.data.length;
      
        ////////// field 26 KH Dosing ///////////
        let field26 = fields[4]; var maxdata26 = 0; var mindata26 = 100;
        let dataEntry26 = {
          label: 'Dosing (dKH)',
          borderColor: '#ffcc66', backgroundColor: '#ffcc66',
          pointHoverBorderColor: 'black', pointHoverRadius: 5, pointHoverBackgroundColor: 'black',
          fill: false,
          yAxisID: 'y-axis-2',
          data: []
        };
        dataEntry26.data = getFieldValues(res, field26);
        for (let k = 0; k<dataEntry26.data.length; k++) {
          dataEntry26.data[k] = dataEntry26.data[k]/1000;
          maxdata26=Math.max(dataEntry26.data[k],maxdata26);
          mindata26=Math.min(dataEntry26.data[k],mindata26);
        }
        data.datasets.push(dataEntry26);

        ////////// field 24 Ref PH signal///////////
        let field24 = fields[2];
        let dataEntry24 = {
          label: 'PH',
          borderColor: '#19f521', backgroundColor: '#19f521',
          pointHoverBorderColor: 'black', pointHoverRadius: 5, pointHoverBackgroundColor: 'black',
          fill: false,
          yAxisID: 'y-axis-1',
          data: []
        };
        dataEntry24.data = getFieldValues(res, field24);
        for (let k = 0; k<dataEntry24.data.length; k++) {
          dataEntry24.data[k] = dataEntry24.data[k]/5000;  // KH2 upload Ph value /100000 --> 50000 to consist KHA lcd display, --> 5000 to display PH value
        }  // handle to replace undefined field27 

    if (user.ph1[sidx] != -1 || serial.startsWith('KH2')) {
        let field27 = fields[5];
        let dataEntry27 = {
          label: 'PH',
          borderColor: '#66cc66', backgroundColor: '#66cc66',
          pointHoverBorderColor: 'black', pointHoverRadius: 5, pointHoverBackgroundColor: 'black',
          fill: false,
          yAxisID: 'y-axis-1',
          data: []
        };
        dataEntry27.data = getFieldValues(res, field27);
        for (let k = 0; k<dataEntry27.data.length; k++) {
          if (dataEntry27.data[k] == undefined && serial.startsWith('KH2')) {  // old data field27 is undefined
            dataEntry27.data[k] = dataEntry24.data[k]; // previous version KH2, PH is in field24 
          } else {dataEntry27.data[k] = (dataEntry27.data[k]/1000).toFixed(2); } 
        }
        data.datasets.push(dataEntry27);
        
        /////// field28 ph after bubbling /////
        if (user.ph1[sidx] != -1) {
            let field28 = fields[6];
            let dataEntry28 = {
              label: 'PH(O)',
              borderColor: '#469949', backgroundColor: '#469949',
              pointHoverBorderColor: 'black', pointHoverRadius: 5, pointHoverBackgroundColor: 'black',
              fill: false,
              yAxisID: 'y-axis-1',
              data: []
            };
            dataEntry28.data = getFieldValues(res, field28);
            for (let k = 0; k<dataEntry28.data.length; k++) {
              dataEntry28.data[k] = (dataEntry28.data[k]/1000).toFixed(2);  
              if (dataEntry28.data[k] == 0) {dataEntry28.data[k] = dataEntry27.data[k];}
            }
            data.datasets.push(dataEntry28);

            /////// field27-field28 delta ph  /////
            let dataEntry27_28 = {
              label: '\u0394PH',
              borderColor: '#48c49d', backgroundColor: '#48c49d',
              pointHoverBorderColor: 'black', pointHoverRadius: 5, pointHoverBackgroundColor: 'black',
              fill: false,
              yAxisID: 'y-axis-2',
              data: []
            };
            for (let k = 0; k<dataEntry28.data.length; k++) {
              dataEntry27_28.data[k] =(dataEntry27.data[k]-dataEntry28.data[k]).toFixed(2);  
            }
            data.datasets.push(dataEntry27_28);
          }
     }  // if field27, 28 available, or KH2
      
    if (user.name === "default" || user.name === "123" || user.name === "khacra") {
        ////////// field 24 Ref PH life signal///////////
        data.datasets.push(dataEntry24);

        ////////// field 25 Ref KH///////////
        let field25 = fields[3];
        let dataEntry25 = {
          label: 'Ref KH',
          borderColor: '#ff80b5', backgroundColor: '#ff80b5',
          pointHoverBorderColor: 'black', pointHoverRadius: 5, pointHoverBackgroundColor: 'black',
          fill: false,
          yAxisID: 'y-axis-1',
          data: []
        };
        dataEntry25.data = getFieldValues(res, field25);
        for (let k = 0; k<dataEntry25.data.length; k++) {
          dataEntry25.data[k] = (dataEntry25.data[k]/1000).toFixed(2);
        }
        data.datasets.push(dataEntry25);
        
        ////////// field 23 Error log //////////
        let field23 = fields[1];
        let dataEntry23 = {
          label: 'Error',
          borderColor: '#80ceff', backgroundColor: '#80ceff',
          pointHoverBorderColor: 'black', pointHoverRadius: 5, pointHoverBackgroundColor: 'black',
          fill: false,
          yAxisID: 'y-axis-2',
          data: []
        };
        dataEntry23.data = getFieldValues(res, field23);
        for (let k = 0; k<dataEntry23.data.length; k++) {
          dataEntry23.data[k] = dataEntry23.data[k]/1000;
        }
        //if (mindata23 < 1.0) {     // old version KHA send 1000 or Tank PH value 123456, then not plot field 23
        data.datasets.push(dataEntry23);
        //}
     } // if super user

     

    let chartOpt = {
      title: {display : false,  // not display
        position : 'top',
        fontSize : 14,
        text: "KH Graph for Device " + serial
      },
      legend: {
            display: true,
            position: 'top'
          },  
      maintainAspectRatio: false,
      animation : false,
      bezierCurve : false,
      responsive: true,
      tooltips: {
          mode: 'index',
          intersect: false,
      },
      hover: {
          mode: 'nearest',
          intersect: false,
          axis: 'x'
      },
      scales: {
        xAxes: [{
          gridLines : {
            display : true
          },
          type: "time",
          time: {
            parser: 'MM/DD/YYYY HH:mm',
            //format: 'MM/DD HH:mm',
            tooltipFormat: 'll HH:mm',
            displayFormats: {          
            'minute': 'HH:mm',
            'hour': 'DD,HH:mm',
            'day': 'MM/DD',
            'week': 'MM/YY',
            'month': 'MM/YY',
            'quarter': 'MM/YY',
            'year': 'YYYY',
            }
          },
          ticks: {fontSize: 14,
            autoSkipPadding: 20,
            maxRotation: 0,
          },
          scaleLabel: {
            display: true,
            fontSize: 14,
            fontColor: 'black',
            //labelString: serial
          }
        },],
        yAxes: [{
          display: true, 
          position: 'left',
          id: 'y-axis-1',
          gridLines : {
            display : true
          },
          scaleLabel: {
            display: true,
            fontSize: 14
            //labelString: 'KH Value'
          },
          ticks: {fontSize : 14, 
                  //stepSize: 0.1,
                  beginAtZero:false, 
                  suggestedMin:Math.max(average22-range22/2,0),
                  suggestedMax:Math.min(average22+range22/2,14)
          }
        },{
          display: true, 
          position: 'right',
          id: 'y-axis-2',
          gridLines : {
            display : true
          },
          scaleLabel: {
            display: true,
            fontSize: 14
          },
          ticks: {fontSize : 14, 
                  beginAtZero:false, 
                  stepSize: 0.1,
                  suggestedMin: 0,
                  suggestedMax: 0.3  //maxdata26*3
          }
        }]
      },
    };

    //console.log('dataset: ', data);
    // Vue.datacollection.labels = data.labels;
    // Vue.datacollection.datasets = data.datasets;
    Vue.datacollection = data;
    Vue.choptions = chartOpt;
    //console.log('datac: ', data, Vue.datacollection);
    //console.log('maxdata=',maxdata,', mindata=', mindata);

      } 
    
  
function ROWToCSV(Vue) {
    let data = Vue.datacollection;
    // Variable to store the final csv data
    //console.log("ROWToCSV: ", data, "data.labels:", data.labels);
    var csv_data = [];
    let csvrow = []; 
    let rowslength = data.datasets.length+1;  // +1 time labels
    
    for (var j = 0; j < data.labels.length; j++) { 
        csvrow = [];  // initialize array
        for (var i = 0; i < rowslength; i++) {    //[time, tank KH, PH signal] length = 3
        
          if (j===0) {  // first row is title label
            if (i===0){
              csvrow.push('time');  
            } else {
              csvrow.push(data.datasets[i-1].label);  // push label 
            } 
          } else { // j >0 then fill data
            if (i===0){  // 1st element is time data
                csvrow.push(data.labels[j]);  // row of time  
            } else {   // other element is data of tank KH, PH signal ....
                csvrow.push(data.datasets[i-1].data[j]);} 
          }  
        } // for i
        //console.log("csvrow= ", csvrow);
        csv_data.push(csvrow.join(",")); // Combine each column value with comma
    } // for j

    csv_data = csv_data.join('\n'); // Combine each row data with new line character
    //console.log("csv_data: ", csv_data);
    downloadCSVFile(Vue, csv_data);  // Call this function to download csv file 

  }
function downloadCSVFile(Vue, csv_data) {
            
    let CSVFile = new Blob([csv_data], {  // Create CSV file object and feed our csv_data into it
        type: "text/csv"
    });
    var temp_link = document.createElement('a'); // Create to temporary link to initiate download process
    let date = new Date().toISOString().
          replace(/T*/, '_').
          replace(/:/g, '').
          replace(/\..+/, '');
    temp_link.download = Vue.serial+date+".csv";
    console.log("output CSV file: ", temp_link.download);
    var url = window.URL.createObjectURL(CSVFile);
    temp_link.href = url;
    temp_link.style.display = "none";   // This link should not be displayed
    document.body.appendChild(temp_link);

    temp_link.click();// Automatically click the link to trigger download
    document.body.removeChild(temp_link);
  }

  

export default {
  components: {
    "line-graph": LineGraph
  },
  data() {
    return {
      title: "KH graph",
      serial:"",
      tankKH: "",
      phSignal: -1,
      ph1:-1,
      KHRemain:"",
      message: "",
      msglist: mlist, 
      devname:"",
			s_number:"",
      er_c:"",
      er_pump:"",
      datacollection: {},
      choptions: {},
      win_width:"",
      win_height:"",
      time_out:"",
      //KHfix:'1'
    }
  },
  
  created() {
    window.addEventListener("resize", this.resizeHandler);
    this.win_width=window.innerWidth;
    this.win_height=window.innerHeight;
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
    clearInterval(this.time_out);
  },
  computed: {

  },
  methods: {
    fillData: function(range) {
      let user = JSON.parse(localStorage.getItem("user")) || this.$store.getters.user || {};   
      //localStorage.setItem('sidx', JSON.stringify(this.$route.params.sidx)); // store params: {"language":"tw","sidx":0} in local storage
      //let idx =  this.$route.params.sidx || localStorage.getItem('sidx');
      let serial = '';
      has(user, 'data.devices') ? serial = user.data.devices[this.$route.params.sidx] : "";
      this.datacollection = { labels: [], datasets: [] };
      getGraph(this, range, serial);
    },
    row2csv: function() {
      ROWToCSV(this);
    },
    resizeHandler() {
      this.win_width=window.innerWidth;
      this.win_height=window.innerHeight;
    },
    getRandomInt: () => {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    }
  },
  mounted() {
    //console.log('mounted: ', this, this.user1);
    let interv = 3600;  // set refresh data timer 1 hour = 3600 sec
	///if (this.$auth.loggedIn()) {  // keep graph page without logout
    this.time_out=setInterval(() => {     // set interval 3600 sec to re-plot KH graph 
   // console.log('mounted: set interval: ', interv );
    return this.fillData(1);
    }, interv*1000);
    return this.fillData(1); // show graph at 1st time
	///} else {
	///	this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
	///}
    //return this.fillData(1);
  }

}

</script>

<style>
.graph {
  max-width: 100%;
  width: 93%;
  min-width: 300px;
  margin: 3% 6% 3% 5%;
}
</style>



// WEBPACK FOOTER //
// KH_graph.vue?35a57eaa